module.exports = __webpack_public_path__ + "img/horizontal_4_1_r_5010.6f312d6e.png";